import { GotoAction } from '@platform-frontend/util';
import { AccountNavigationExtras } from './model/account-navigation-extras';

export abstract class AccountGotoAction<T extends AccountNavigationExtras = AccountNavigationExtras> extends GotoAction {
  constructor(public extras?: T) {
    super(extras);
  }
}
